import useCurrentUser from '@/composables/data/useCurrentUser'

export default function useOrgInviteUrl() {
  const { data: user } = $(useCurrentUser())

  if (user.org.shareToken) {
    return `${window.location.origin}/signup?orgShareToken=${user.org.shareToken}`
  } else return null
}
